import { type FC, useCallback } from 'react'

import IconChevronDown from '@/assets/icons/icon-chevron-down.svg'
import {
  DropdownMenu,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu.tsx'
import { DIALOG_TYPE } from '@/dialogs/constants.ts'
import { openDialog } from '@/models/dialogs.ts'
import { setSelectedMediaIds } from '@/models/vault/medias'

export interface MediaOption {
  mediaId: number
  name: string
  sorting: number
}

export interface MediaSelection {
  mediaId: number
  sorting: number
}

interface Props {
  selected: MediaSelection[]
  onSelect: (selected: MediaSelection[]) => void
}

export const MessageMediaDropdown: FC<Props> = ({ onSelect, selected }) => {
  const selectedText =
    selected.length === 0
      ? 'Select Media'
      : `${selected.length} item${selected.length > 1 ? 's' : ''} selected`

  const handleSelectOpenChange = useCallback(() => {
    setSelectedMediaIds(selected.map(({ mediaId }) => mediaId))
    openDialog({
      type: DIALOG_TYPE.MESSAGE_MEDIA_SELECTION,
      isPersistent: true, // otherwise selected ids are resetting if you open preview
      onSelect,
    })
  }, [onSelect, selected])

  return (
    <DropdownMenu onOpenChange={handleSelectOpenChange}>
      <DropdownMenuTrigger
        testId="message-media-dropdown"
        className="flex h-[40px] w-full items-center justify-between rounded-md border bg-card px-3 py-2 text-title focus:border-primary-500 focus:outline-primary-500"
      >
        <span className="truncate">{selectedText}</span>
        <IconChevronDown className="ml-auto h-4 w-4 flex-shrink-0 text-title" />
      </DropdownMenuTrigger>
    </DropdownMenu>
  )
}
